import React, { Component } from 'react';
import {
  Button,
  FormGroup, Label,
  Input,
  Row, Col,
  Card, CardBody
} from 'reactstrap';

// import {
//   faCalendarAlt,

// } from '@fortawesome/free-solid-svg-icons';

// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// import DatePicker from 'react-datepicker';

import { messages } from '../../constants/constant.message';

import './EditSocialDetails.css';
const { INVALID_FACEBOOK, INVALID_WEBSITE, INVALID_INSTAGRAM, 
  // EMPTY_BIRTHDATE 
} = messages.PROFILE;

class EditSocialDetails extends Component {

  handleOnCancel = () => {
    this.props.onCancel('isSocialEditActive', false);
  }

  render() {
    const { 
      // birthDate, anniversaryDate, 
      facebook, instagram, website } = this.props;

    return <Card className={this.props.className}>
      <CardBody>
        <Row>
          <Col>
            <b>SOCIAL DETAILS</b>
          </Col>
        </Row>
        <hr />
        <Row>
          {/* <Col xl="3" md="12" xs="12">
            <FormGroup>
              <Label for="password">Birth Date <span className="required-field">*</span></Label>
              <div className="width-100">
                <Label onClick={e => this.bday.state.open && e.preventDefault()} >
                  <InputGroup className="social-detail-date">
                    <DatePicker className={"form-control" + " " + this.props.inputClassName}
                      selected={birthDate.value}
                      onChange={this.props.handleBirthDateChange}
                      showMonthDropdown
                      ref={r => this.bday = r}
                      
                      dateFormat="dd/MM/yyyy"
                      showYearDropdown
                      shouldCloseOnSelect
                      maxDate={new Date()}
                      dropdownMode="select"
                      style={{ zIndex: 'auto' }}
                      onFocus={this.props.activeFragment ? this.props.activeFragment.bind(this, 'social') : null}
                    />
                    <InputGroupAddon addonType="append" >
                      <div className="input-group-text" style={{ zIndex: 'auto !important' }}>
                        <FontAwesomeIcon htmlFor="datepicker" icon={faCalendarAlt} />
                      </div>
                    </InputGroupAddon>
                  </InputGroup>
                </Label>

               
                {birthDate.showErrorMsg && <div className="error">* {EMPTY_BIRTHDATE}</div>}
              </div>
           
            </FormGroup>
          </Col> */}
          {/* <Col xl="3" md="12" xs="12">
            <Label for="password">Anniversary Date</Label>
            <div className="width-100">

              <Label onClick={e => this.anny.state.open && e.preventDefault()} >
                <InputGroup className="social-detail-date">
                  <DatePicker className={"form-control" + " " + this.props.inputClassName}
                    selected={anniversaryDate.value}
                    onChange={this.props.handleAnniversaryDateChange}
                    showMonthDropdown
                    ref={r => this.anny = r}
                  
                    dateFormat="dd/MM/yyyy"
                    showYearDropdown
                    shouldCloseOnSelect
                    maxDate={new Date()}
                    style={{ zIndex: 'auto' }}
                    dropdownMode="select"
                    onFocus={this.props.activeFragment ? this.props.activeFragment.bind(this, 'social') : null}
                  />
                  <InputGroupAddon addonType="append" >
                    <div className="input-group-text" style={{ zIndex: 'auto !important' }}>
                      <FontAwesomeIcon htmlFor="datepicker" icon={faCalendarAlt} />
                    </div>
                  </InputGroupAddon>
                </InputGroup>
              </Label>
 
            </div>
          
          </Col> */}
          <Col xl="3" md="12" xs="12">
            <FormGroup>
              <Label for="facebook">Facebook Page</Label>
              <Input
                type="facebook"
                name="facebook"
                id="facebook"
                value={facebook.value}
                onChange={this.props.handleInputChange}
                placeholder="Type here" />
              {facebook.showErrorMsg && <div className="error">* {INVALID_FACEBOOK}</div>}
            </FormGroup>
          </Col>
          <Col xl="3" md="12" xs="12">
            <FormGroup>
              <Label for="instagram">Instagram Page</Label>
              <Input
                type="instagram"
                name="instagram"
                id="instagram"
                value={instagram.value}
                onChange={this.props.handleInputChange}
                placeholder="Type here" />
              {instagram.showErrorMsg && <div className="error">* {INVALID_INSTAGRAM}</div>}
            </FormGroup>
          </Col>
          {/* </Row> */}
          {/* <Row> */}
          <Col xl="6" md="12" xs="12">
            <FormGroup>
              <Label for="website">Website</Label>
              <Input
                type="text"
                name="website"
                id="website"
                value={website.value}
                onChange={this.props.handleInputChange}
                placeholder="Type here" />
              {website.showErrorMsg && <div className="error">* {INVALID_WEBSITE}</div>}
            </FormGroup>
          </Col>
        </Row>
        {this.props.onSave && <Row>
          <Col xl="12" xs="12" md="12" className="text-align-right" >
            <Button className="mb-1 mr-1 btn-pill action-button profile-cancel-button" color="dark" onClick={this.handleOnCancel}>Cancel</Button>
            <Button className="mb-1 mr-1 btn-pill action-button profile-save-button" color="warning" onClick={this.props.onSave}>Save</Button>
          </Col>
        </Row>}
      </CardBody>
    </Card>;
  }
}

export default EditSocialDetails;
